import React from "react";
import { chain, map, sum } from "lodash";
import { FirebaseError } from "firebase/app";
import {
  query,
  where,
  orderBy,
  Timestamp,
  collection,
  onSnapshot,
  DocumentData,
  QuerySnapshot,
} from "firebase/firestore";

import { db } from "configs";
import { Utils } from "utils";
import { COLLECTIONS } from "constants/firebase";
import { IPlaceCollectLog, Iterable } from "types";

type Data = { tag: string; places: number; createdAt: Timestamp };

export const useCollectingData = (countryCode?: string) => {
  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState<Data[]>([]);

  const handleSnapshot = (snapshot: QuerySnapshot<DocumentData>) => {
    const documents =
      Utils.Helpers.castDocs<Iterable<IPlaceCollectLog>>(snapshot);

    const groupped = chain(documents)
      .groupBy("tag")
      .map((items, tag) => ({
        tag,
        createdAt: items[0].createdAt,
        places: sum(map(items, "places")),
      }))
      .value();

    setData(groupped);
    setLoading(false);
  };

  const handleError = (error: FirebaseError) => {
    setLoading(false);
  };

  React.useEffect(() => {
    const ref = collection(db, COLLECTIONS.PLACES_LOGS);
    const options = [
      orderBy("createdAt", "asc"),
      where("status", "==", "Completed"),
    ];
    if (countryCode) options.push(where("countryCode", "==", countryCode));
    const q = query(ref, ...options);
    const snapshot = onSnapshot(q, handleSnapshot, handleError);

    return () => {
      snapshot();
    };
  }, [countryCode]);

  return { loading, data } as const;
};
